import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

export const WhatYouGet = () => {
  const { t } = useTranslation();
  const items = t('whatYouGet.items', { returnObjects: true });

  return (
    <section 
      id="what-you-get" 
      className="py-14 md:py-20 bg-stone-50"
      data-testid="what-you-get-section"
    >
      <div className="max-w-3xl mx-auto px-6">
        <h2 
          className="text-xl md:text-2xl font-semibold text-[#1B4D3E] text-center mb-8"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('whatYouGet.headline')}
        </h2>

        <div className="bg-white rounded-xl p-6 md:p-8 border border-stone-200">
          <ul className="space-y-4">
            {items.map((item, index) => (
              <li 
                key={index}
                className="flex items-start gap-3"
                data-testid={`what-you-get-item-${index}`}
              >
                <div className="w-5 h-5 bg-[#1B4D3E]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-3 h-3 text-[#1B4D3E]" />
                </div>
                <span className="text-stone-700">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
